converter = new showdown.Converter()

@app.filter "markdown", ->
  (input) ->
    if input && converter
      result = converter.makeHtml(input)
      result
    else
      ""
